<template>
	<div id="gdtComponent">	
	</div>


</template>
<script>
	export default {
		data(){
			return{
			}
		},
		mounted() {
			if(typeof(window) != 'undefined'){
				this.toGdt();
			}
		},
		methods: {
			toGdt(){
				let _url = this.common.GetQueryString('gdtUrl');
				if(_url != 'undefined'){
					window.location.href = decodeURIComponent(_url);
				}
			}
		},
	};

</script>
<style></style>


// WEBPACK FOOTER //
// ./src/views/gdt.vue